import { render, staticRenderFns } from "./epics_list_empty.vue?vue&type=template&id=284ef39c&"
import script from "./epics_list_empty.vue?vue&type=script&lang=js&"
export * from "./epics_list_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports